import { FC } from 'react';
import { Image, Link, Page, Text, View } from '@react-pdf/renderer';
import { styles } from './styles';
import { TilePageNumber, TilesData, translations } from './interfaces';
import { PageNumberFooter, sideLogo } from './helper';

interface ITableOfContents {
  tilesData: TilesData[];
  translations: translations;
  tilePageNumber: TilePageNumber[];
}

export const TableOfContents: FC<ITableOfContents> = ({
  tilesData,
  translations,
  tilePageNumber
}) => {
  const TableOfContentsElements: React.ReactNode[] = [];
  tilesData.forEach(toc => {
    const tocPage: React.ReactNode[] = [];

    tocPage.push(
      <View key={toc.category}>
        <Text
          key={toc.category}
          style={{ fontWeight: 'bold', fontSize: '18px' }}
        >
          {toc.category}
        </Text>
      </View>
    );
    toc.tiles.forEach((tile, index) => {
      tocPage.push(
        <View style={styles.tocEntry} key={`tocEntry-${tile.id}`}>
          <Link key={index} src={`#${tile.id}`} style={styles.tocLink}>
            <Text style={styles.tocTitle}>{tile.title}</Text>
            <Text
              style={styles.tocPageNumber}
              render={() => {
                const pageNumber = tilePageNumber.find(
                  tpn => tpn.id === tile.id
                )?.no;

                return pageNumber;
              }}
            />
          </Link>
        </View>
      );
    });

    TableOfContentsElements.push(
      <Page
        size="A4"
        style={[styles.page, styles.toc]}
        orientation="landscape"
        key={`tocPage-${toc.category}`}
      >
        <Image source={sideLogo(translations.language)} style={styles.logo} />
        <Text style={styles.header}>{translations.tocTitle}</Text>
        <View>{tocPage}</View>
        <PageNumberFooter />
      </Page>
    );
  });

  return <>{TableOfContentsElements}</>;
};
